// src/layouts/PrivateLayout.js
import React from "react";

const PrivateLayout = ({ children }) => {
  return (
    <div className="private-layout">
      {/* Aqui você pode adicionar cabeçalhos, barras laterais, etc. */}
      {children}
    </div>
  );
};

export default PrivateLayout;

